import * as React from 'react';

import { LabelsBox } from '../../components/LabelsBox';
import * as styles from './RedesignedLabelsContainer.css';

type TRedesignedLabelsContainerProps = {
  visited: boolean;
};

export const RedesignedLabelsContainer: React.FC<TRedesignedLabelsContainerProps> = ({ visited }) => {
  if (!visited) {
    return null;
  }

  return (
    <LabelsBox>
      <span className={styles['visited-label']}>Вы смотрели</span>
    </LabelsBox>
  );
};
